import { Loading } from '@winnin/winnin_ui.components.loading'

import { ListGlobalTopicsPage } from 'modules/global-topic'
import SearchTerritoriesPageWrapper from 'pages/SearchTerritoriesPage'

import type { ISearchTerritoryPageSelector } from './search-territory-page-selector.types'

export const SearchTerritoryPageSelectorView = ({
  isGlobalTaxonomyWorkspace,
  isGlobalTaxonomyEnabled,
  isQueryInformationAvailable,
}: ISearchTerritoryPageSelector) => {
  if (!isQueryInformationAvailable) {
    return <Loading />
  }
  if (isGlobalTaxonomyWorkspace) {
    return <ListGlobalTopicsPage isGlobalTaxonomyEnabled={isGlobalTaxonomyEnabled} />
  }
  return <SearchTerritoriesPageWrapper />
}
